import React from "react";
import { Controller } from "react-hook-form";
import { FormGroup, Input } from "@cofano/cck";
import { Grid } from "@mui/material";
import { Language } from "imports/Utils";

export default ({ control }) => {
	return (
		<Grid xs={6} item>
			<FormGroup label={Language("CREDITOR")} labelPlacement="left-center" overflow="hidden">
				<Controller
					name="protestVariables.operator"
					control={control}
					render={({ field }) => <Input {...field} />} />
			</FormGroup>

			<FormGroup label={Language("CONTRACT_SHIP_NAME")} labelPlacement="left-center" overflow="hidden">
				<Controller
					name="protestVariables.shipName"
					control={control}
					render={({ field }) => <Input {...field} />} />
			</FormGroup>

			<FormGroup label={Language("VOYAGE_NUMBER")} labelPlacement="left-center" overflow="hidden">
				<Controller
					name="protestVariables.voyageNumber"
					control={control}
					render={({ field }) => <Input {...field} />} />
			</FormGroup>
		</Grid>
	);
};

